export const fileExtensions = ['png', 'jpeg', 'pdf', 'jpg']; //Tipos de ficheros aceptados
export const fileExtensionsButton = '.png,.jpeg,.pdf,.jpg'; //Tipos de ficheros aceptados
export const photoExtensions = ['png', 'jpeg', 'jpg']; //Tipos de ficheros aceptados
export const encryptionKey = 'AccionaOCR'; //Clave de encriptación
